module.exports = __webpack_public_path__ + "img/mediawall_image.7e01abcf.jpg";